export type PkPlayer = { playerId:number; pk:boolean; kills:number; expiresAt:number };

export class PvpState {
  supported=false;
  mobileEnabled=false;
  players=new Map<number,PkPlayer>();
  keys=new Set<string>();
  private listeners=new Set<()=>void>();
  subscribe(listener:()=>void){this.listeners.add(listener);return()=>{this.listeners.delete(listener);};}
  private changed(){for(const listener of this.listeners)listener();}
  clearKeys(){if(!this.keys.size)return;this.keys.clear();this.changed();}
  suspend(){const changed=this.mobileEnabled||this.keys.size>0;this.mobileEnabled=false;this.keys.clear();if(changed)this.changed();}
  reset(){this.supported=false;this.mobileEnabled=false;this.players.clear();this.keys.clear();this.changed();}
  toggleMobile(){if(!this.supported)return false;this.mobileEnabled=!this.mobileEnabled;this.changed();return true;}
  key(code:string,down:boolean,repeat=false){
    const before=this.keys.size;
    if(!down)this.keys.delete(code);
    else if(!repeat&&['ShiftLeft','ShiftRight','ControlLeft','ControlRight'].includes(code))this.keys.add(code);
    if(this.keys.size!==before)this.changed();
  }
  forced(){return this.supported&&(this.mobileEnabled||((this.keys.has('ShiftLeft')||this.keys.has('ShiftRight'))&&(this.keys.has('ControlLeft')||this.keys.has('ControlRight'))));}
  snapshot(data:unknown):boolean{
    if(!data||typeof data!=='object'||!('players' in data)||!Array.isArray(data.players)||data.players.length>4096)return false;
    const next=new Map<number,PkPlayer>();
    for(const p of data.players){
      if(!p||!Number.isInteger(p.playerId)||p.playerId<=0||typeof p.pk!=='boolean'||!Number.isInteger(p.kills)||p.kills<0||!Number.isSafeInteger(p.expiresAt)||p.expiresAt<0)return false;
      next.set(p.playerId,{playerId:p.playerId,pk:p.pk,kills:p.kills,expiresAt:p.expiresAt});
    }
    this.players=next;this.supported=true;this.changed();return true;
  }
  isRed(id:number,now=Date.now()/1000){const p=this.players.get(id);return !!p?.pk&&p.expiresAt>now;}
}
